package com.demo.portfolio_demo.components.model

data class EducationData(
    val degree: String,
    val institution: String,
    val duration: String
)
